module.exports = __webpack_public_path__ + "img/1bit-swords.8c17de87.png";